module.exports = __webpack_public_path__ + "img/title+@3x.5cda8bd9.png";